import { STATUS_FLOW } from "@/lib/constants";
import { Check, Zap } from "lucide-react";
import { cn } from "@/lib/utils";

export const StatusStepper = ({ currentStatus, history = [] }) => {
  const idx = Math.max(0, STATUS_FLOW.indexOf(currentStatus));

  return (
    <div className="surface-card p-5 sm:p-8" data-testid="status-stepper">
      {/* Desktop: horizontal */}
      <ol className="hidden md:flex items-start justify-between gap-2">
        {STATUS_FLOW.map((stage, i) => {
          const isDone = i < idx;
          const isActive = i === idx;
          return (
            <li key={stage} className="flex-1 flex flex-col items-center text-center relative">
              {i > 0 && (
                <div
                  className={cn(
                    "absolute top-5 right-1/2 w-full h-[2px]",
                    i <= idx ? "bg-spark-teal" : "bg-spark-line"
                  )}
                />
              )}
              <div
                className={cn(
                  "relative z-10 size-10 rounded-full flex items-center justify-center border-2 transition-colors",
                  isDone && "bg-spark-teal border-spark-teal text-white",
                  isActive && "bg-spark-yellow border-spark-yellow text-spark-ink animate-spark-pulse",
                  !isDone && !isActive && "bg-white border-spark-line text-spark-slate"
                )}
                data-testid={`stepper-node-${i}`}
              >
                {isDone ? <Check className="size-5" /> : isActive ? <Zap className="size-5 fill-spark-ink" /> : i + 1}
              </div>
              <span
                className={cn(
                  "mt-3 font-display uppercase tracking-wide text-sm leading-tight max-w-[110px]",
                  (isDone || isActive) ? "text-spark-ink font-bold" : "text-spark-slate"
                )}
              >
                {stage}
              </span>
            </li>
          );
        })}
      </ol>

      {/* Mobile: vertical */}
      <ol className="md:hidden space-y-4">
        {STATUS_FLOW.map((stage, i) => {
          const isDone = i < idx;
          const isActive = i === idx;
          return (
            <li key={stage} className="flex items-start gap-3">
              <div
                className={cn(
                  "size-9 rounded-full flex items-center justify-center border-2 shrink-0",
                  isDone && "bg-spark-teal border-spark-teal text-white",
                  isActive && "bg-spark-yellow border-spark-yellow text-spark-ink animate-spark-pulse",
                  !isDone && !isActive && "bg-white border-spark-line text-spark-slate"
                )}
              >
                {isDone ? <Check className="size-4" /> : isActive ? <Zap className="size-4 fill-spark-ink" /> : i + 1}
              </div>
              <div className="flex-1 pt-1">
                <p className={cn("font-display uppercase tracking-wide text-base", (isDone || isActive) ? "text-spark-ink font-bold" : "text-spark-slate")}>
                  {stage}
                </p>
                {isActive && (
                  <p className="text-xs text-spark-slate mt-0.5">Current stage</p>
                )}
              </div>
            </li>
          );
        })}
      </ol>

      {history?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-spark-line">
          <p className="label-mono mb-3">Activity log</p>
          <ul className="space-y-2 text-sm" data-testid="status-history">
            {[...history].reverse().map((h, i) => (
              <li key={i} className="flex items-baseline gap-3">
                <span className="font-display uppercase tracking-wider text-xs text-spark-teal min-w-[140px]">
                  {h.status}
                </span>
                <span className="text-spark-slate text-xs">
                  {new Date(h.at).toLocaleString("en-NZ", { dateStyle: "medium", timeStyle: "short" })}
                </span>
                {h.note && <span className="text-spark-slate text-xs italic">— {h.note}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StatusStepper;
